import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import {
  uploadExpenseRedux,
  getAllPendingExpenseByDayRedux,
  getAllPendingCashInByDayRedux,
  deleteExpenseRedux,
  updateExpenseRedux,
  updateCashInRedux,
  deleteCashInRedux,
  getAllExpenseRedux,
  getAllCashInsRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./cash-summary.css";

const CATEGORY_COLORS = {
  "LOAN": "purple",
  "INVEST": "blue",
  "OTHERS": "gray",
  "ORDERS": "green",
  "DAILY COST": "orange",
  "OFFICE": "teal",
  "SALARY": "pink",
  "SHIPPING": "indigo",
  "BOOSTING": "amber",
  "REFUND": "red",
  "TRANSPORT": "cyan",
  "BUY PRODUCTS": "violet",
};

function categoryColorClass(category) {
  const key = String(category || "").toUpperCase().trim();
  return `cs-badge--${CATEGORY_COLORS[key] || "gray"}`;
}

export class DailyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      singleLot: null,
      expenseObj: null,
      loader: false,
      type: "expense",
      filterCategoryCashIn: "",
      filterCategoryCashOut: "",
    };
  }

  componentDidMount = async () => {
    let [day, month, year] = this.props.match.params.date.split("-");
    day = parseInt(day);
    month = parseInt(month) - 1;
    year = parseInt(year);
    let date = new Date(year, month, day);
    this.props.getAllExpenseRedux(date.toLocaleDateString("en-GB"));
    this.props.getAllCashInsRedux(date.toLocaleDateString("en-GB"));
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { type } = this.state;
    const { expenses, cashIns } = this.props;
    let [day, month, year] = this.props.match.params.date.split("-");
    day = parseInt(day);
    month = parseInt(month) - 1;
    year = parseInt(year);
    let date = new Date(year, month, day);

    let renderableExpense = expenses;
    if (this.state.filterCategoryCashOut) {
      renderableExpense = expenses.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashOut.toLowerCase()
      );
    }

    let renderableCashIn = cashIns;
    if (this.state.filterCategoryCashIn) {
      renderableCashIn = cashIns.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashIn.toLowerCase()
      );
    }

    // Cash only moves when an entry is approved, which is exactly what the
    // day's Total Cash In / Total Cash Out on the month view counts. Summing
    // pending rows here too is what made the two screens disagree. Pending
    // rows are still listed — flagged, and left out of the total.
    const isApproved = (entry) => entry.status === "approved";
    const sumApproved = (list) =>
      list.reduce(
        (sum, entry) =>
          isApproved(entry) ? sum + (parseInt(entry.amount) || 0) : sum,
        0
      );

    const total = sumApproved(renderableExpense);
    const totalCashIns = sumApproved(renderableCashIn);
    const pendingExpenseCount = renderableExpense.filter(
      (entry) => !isApproved(entry)
    ).length;
    const pendingCashInCount = renderableCashIn.filter(
      (entry) => !isApproved(entry)
    ).length;

    return (
      <Fragment>
        <Breadcrumb title={date.toDateString()} parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid cs-page kd-cash kd-st--butter">
          <div
            className="nav nav-tabs tab-coupon cs-tablist"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              className={`nav-link cs-tab ${type === "expense" ? "show" : ""}`}
              onClick={() => this.setState({ type: "expense" })}
            >
              Cash Out
            </button>

            <button
              type="button"
              className={`nav-link cs-tab ${type === "cashIn" ? "show" : ""}`}
              onClick={() => this.setState({ type: "cashIn" })}
            >
              Cash In
            </button>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card cs-card">
                <div
                  className="card-header cs-card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  <h5 className="cs-card-title">
                    <i
                      className={`icofont-money cs-card-icon ${
                        type === "cashIn" ? "cs-card-icon--success" : ""
                      }`}
                    ></i>
                    {date.toDateString()}
                  </h5>
                  {type === "expense" ? (
                    <select
                      title="Filter by category"
                      required
                      name="filterCategoryCashOut"
                      className="custom-select cs-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.filterCategoryCashOut}
                    >
                      <option value="">Filter by category </option>
                      <option value="">All</option>
                      <option value="DAILY COST">Daily cost</option>
                      <option value="OFFICE">Office</option>
                      <option value="SALARY">Salary</option>
                      <option value="LOAN">Loan</option>
                      <option value="SHIPPING">Shipping</option>
                      <option value="Boosting">Boosting/promotion</option>
                      <option value="REFUND">Refund</option>
                      <option value="TRANSPORT">Transport</option>
                      <option value="BUY PRODUCTS">Buy products</option>
                    </select>
                  ) : (
                    <select
                      title="Filter by category"
                      required
                      name="filterCategoryCashIn"
                      className="custom-select cs-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.filterCategoryCashIn}
                    >
                      <option value="">Filter by category </option>
                      <option value="">All </option>
                      <option value="LOAN">Loan</option>
                      <option value="OTHERS">Others</option>
                      <option value="ORDERS">Orders</option>
                    </select>
                  )}
                </div>
                <div className="card-body">
                  <div
                    className={`cs-total-chip ${
                      type === "cashIn" ? "cs-total-chip--success" : ""
                    }`}
                  >
                    <span className="cs-total-chip-label cs-stamp-font">
                      {type === "expense" ? "Cash Out Total" : "Cash In Total"}
                    </span>
                    <span className="cs-total-chip-value">
                      {type === "expense" ? total : totalCashIns}Tk
                    </span>
                  </div>
                  {(type === "expense"
                    ? pendingExpenseCount
                    : pendingCashInCount) > 0 && (
                    <p className="cs-rebuild-note">
                      {type === "expense"
                        ? pendingExpenseCount
                        : pendingCashInCount}{" "}
                      pending entr
                      {(type === "expense"
                        ? pendingExpenseCount
                        : pendingCashInCount) === 1
                        ? "y is"
                        : "ies are"}{" "}
                      listed below but not counted in this total — cash moves
                      only once approved.
                    </p>
                  )}
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div className="cs-table-wrap">
                      <table className="table cs-table">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Category</th>
                            <th scope="col">Sub Category</th>
                            <th scope="col">Note</th>
                            <th scope="col">Status</th>
                            <th scope="col">Amount</th>
                          </tr>
                        </thead>
                        {type === "expense" ? (
                          <tbody>
                            {renderableExpense.length === 0 ? (
                              <tr>
                                <td colSpan={6} className="cs-empty">
                                  <EmptyState>No cash out entries for this day.</EmptyState>
                                </td>
                              </tr>
                            ) : (
                              renderableExpense.map((expense, index) => (
                                <tr
                                  key={index}
                                  className={
                                    isApproved(expense) ? "" : "cs-row--pending"
                                  }
                                >
                                  <th scope="row">{index + 1}</th>
                                  <td>
                                    <span
                                      className={`cs-badge ${categoryColorClass(
                                        expense.category
                                      )}`}
                                    >
                                      {expense.category}
                                    </span>
                                  </td>
                                  <td>
                                    {String(expense.subCategory || "").replace(
                                      /^undefined-/,
                                      ""
                                    )}
                                  </td>
                                  <td>{expense.note}</td>
                                  <td>
                                    <span
                                      className={`cs-badge ${
                                        isApproved(expense)
                                          ? "cs-badge--green"
                                          : "cs-badge--amber"
                                      }`}
                                    >
                                      {isApproved(expense)
                                        ? "Approved"
                                        : "Pending"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="cs-amount-pill cs-amount-pill--out">
                                      {expense.amount}Tk
                                    </span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        ) : (
                          <tbody>
                            {renderableCashIn.length === 0 ? (
                              <tr>
                                <td colSpan={6} className="cs-empty">
                                  <EmptyState>No cash in entries for this day.</EmptyState>
                                </td>
                              </tr>
                            ) : (
                              renderableCashIn.map((expense, index) => (
                                <tr
                                  key={index}
                                  className={
                                    isApproved(expense) ? "" : "cs-row--pending"
                                  }
                                >
                                  <th scope="row">{index + 1}</th>
                                  <td>
                                    <span
                                      className={`cs-badge ${categoryColorClass(
                                        expense.category
                                      )}`}
                                    >
                                      {expense.category}
                                    </span>
                                  </td>
                                  <td>
                                    {String(expense.subCategory || "").replace(
                                      /^undefined-/,
                                      ""
                                    )}
                                  </td>
                                  <td>{expense.note}</td>
                                  <td>
                                    <span
                                      className={`cs-badge ${
                                        isApproved(expense)
                                          ? "cs-badge--green"
                                          : "cs-badge--amber"
                                      }`}
                                    >
                                      {isApproved(expense)
                                        ? "Approved"
                                        : "Pending"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="cs-amount-pill cs-amount-pill--in">
                                      {expense.amount}Tk
                                    </span>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
    expenses: state.expenses.expenses,
    cashIns: state.cashIns.cashIns,
  };
};

export default connect(mapStateToProps, {
  uploadExpenseRedux,
  deleteExpenseRedux,
  deleteCashInRedux,
  updateCashInRedux,
  updateExpenseRedux,
  getAllPendingExpenseByDayRedux,
  getAllPendingCashInByDayRedux,
  getAllExpenseRedux,
  getAllCashInsRedux,
})(DailyExpense);
